export interface RegisterTrackingParams {
  imRef: string | null;
  irpid: string | null;
}

export function getRegisterTrackingParams(
  currentSearch = '',
  storedUrlParams: string | null = '',
): RegisterTrackingParams {
  const searchParams = new URLSearchParams(storedUrlParams || '');

  new URLSearchParams(currentSearch).forEach((value, key) => {
    if (!value) {
      return;
    }

    searchParams.set(key, value);
  });

  return {
    imRef: searchParams.get('im_ref'),
    irpid: searchParams.get('irpid'),
  };
}
